const LIMIT = 3;
const BASE_URL = '/api/collections/courses/entries';
const FIELDS = 'url,title,box_text,header_text,attendees_count,duration';
const TRACKING_ELEMENT = 'product-tracker';

// https://alpinejs.dev/plugins/persist#using-persist-with-alpine-data
export default function () {
  return {
    products: [],
    trackedProducts: this.$persist([]),

    get formatedCondition() {
      if (this.trackedProducts.length > 0) {
        return this.trackedProducts.join('|');
      }
      return '';
    },

    init() {
      this.getProducts();
      this.trackProducts();
    },

    getProducts() {
      if (this.formatedCondition !== '') {
        fetch(
          `${BASE_URL}?limit=${LIMIT}&fields=${FIELDS}&filter[id:in]=${this.formatedCondition}`
        )
          .then((response) => response.json())
          .then((response) => {
            this.products = response.data;
          });
      }
    },

    trackProducts() {
      const tracker = document.getElementById(TRACKING_ELEMENT);
      if (tracker && tracker.dataset.id.length > 0) {
        let currentStack = this.trackedProducts;
        currentStack.push(tracker.dataset.id);
        let uniqueStack = [...new Set(currentStack)];
        this.trackedProducts = uniqueStack.slice(
          Math.max(uniqueStack.length - 3, 0)
        );
      }
    },

    tcDuration(duration) {
      if (duration < 1) {
        let customDuration = Math.round(duration * 24);
        if (customDuration === 1) {
          return `${customDuration} hodina`;
        }
        if (customDuration > 1 && customDuration <= 4) {
          return `${customDuration} hodiny`;
        }
        return `${customDuration} hodin`;
      }
      if (duration === 1) {
        return `${duration} den`;
      }
      if (duration > 1 && duration <= 4) {
        return `${duration} dny`;
      }
      return `${duration} dnů`;
    },
  };
}
